export default __webpack_public_path__ + "static/media/phone2.a2a3c827.png";